import React, { Component } from 'react';
import PropTypes from 'prop-types';

import '../styles/b2b-dashboard-item.css';

class B2BDashboardItem extends Component {
  render() {
    const { t } = this.context;
    const { label, value, icon, round } = this.props;

    return (
      <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
        <div className="info-box bg-pink hover-expand-effect">
          <div className="icon">
            <i className={icon}></i>
          </div>
          <div className="content">
            <div className="text">{t(label)}</div>
            <div className="number count-to">
              {round ? value.toFixed(round) : value}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

B2BDashboardItem.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default B2BDashboardItem;



// WEBPACK FOOTER //
// ./src/app/main/dashboard/components/b2b-dashboard-item.js